<template>
    <ul class="steps has-content-centered is-horizontal">
        <li class="steps-segment" :class="{'is-active': step === 1}">
            <span class="steps-marker"><b-icon icon="clipboard-text" size="is-small" /></span>

            <div class="steps-content">
                <h5 class="is-size-6">{{$t('students.contactModal.steps.projectInformation')}}</h5>
            </div>
        </li>

        <li class="steps-segment" :class="{'is-active': step === 2}">
            <span class="steps-marker"><b-icon icon="account" size="is-small" /></span>

            <div class="steps-content">
                <h5 class="is-size-6">{{$t('students.contactModal.steps.yourInformation')}}</h5>
            </div>
        </li>

        <li class="steps-segment" :class="{'is-active': step === 3}">
            <span class="steps-marker"><b-icon icon="check-outline" size="is-small" /></span>

            <div class="steps-content">
                <h5 class="is-size-6">{{$t('students.contactModal.steps.review')}}</h5>
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            step: {
                type: Number,
                required: true,
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/taskflex/students/components/contact/Steps.vue